export default class DtoBoreholeAquiferItem {
    constructor(obj) {
        this.aquiferId = obj.aquiferId
        this.order = obj.order
        this.depth = obj.depth
        this.comment = obj.comment
        this.headers = ['depth', 'comment']
    }
}